import { createSelector } from 'reselect';

const selectDomain = (state) => state.cards;

export const selectCardsById = createSelector(
  [selectDomain], (state) => state.get('cardsById'),
);

export const selectCardsLoaded = createSelector(
  [selectDomain], (state) => state.get('cardsLoaded'),
);
